import React from 'react';
import Icon from './AppIcon';

const CaseSubmissionWarningModal = ({ isOpen, onClose, onConfirm, isSubmitting }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-lg shadow-xl max-w-lg w-full">
        <div className="p-6">
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 bg-warning/10 rounded-full">
              <Icon name="AlertTriangle" size={32} className="text-warning" />
            </div>
          </div>

          <h2 className="text-2xl font-bold text-foreground text-center mb-2">
            Final Submission Warning
          </h2>
          <p className="text-muted-foreground text-center mb-6">
            This submission is <span className="font-semibold text-foreground">final and cannot be edited</span>. Any revisions or additions will require creating a new case and will consume an additional credit.
          </p>

          <div className="bg-muted/30 rounded-lg p-4 mb-6">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} className="text-primary mt-0.5" />
              <div className="space-y-2 text-sm text-foreground">
                <p><strong>What happens after submission:</strong></p>
                <ul className="list-disc list-inside space-y-1 text-muted-foreground">
                  <li>Case details and uploads are locked</li>
                  <li>AI analysis begins immediately</li>
                  <li>One credit will be consumed</li>
                  <li>Changes require creating a new case</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <button
              onClick={onConfirm}
              disabled={isSubmitting}
              className="w-full px-4 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-smooth disabled:opacity-50 flex items-center justify-center gap-2"
            >
              {isSubmitting ? (
                <>
                  <Icon name="Loader2" size={18} className="animate-spin" />
                  Submitting...
                </>
              ) : (
                <>
                  <Icon name="Check" size={18} />
                  Yes, Submit Case
                </>
              )}
            </button>
            <button
              onClick={onClose}
              disabled={isSubmitting}
              className="w-full px-4 py-3 bg-background border border-border text-foreground rounded-lg font-medium hover:bg-muted transition-smooth disabled:opacity-50"
            >
              Review Again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseSubmissionWarningModal;